import React from 'react';

export const TestCard = ({ children }) => {
  return <>{children}</>;
};
